/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Recap_DevicesInputs */

const en_funnel_ob_recap_devices = /** @type {(inputs: Funnel_Ob_Recap_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use it on web, Mac & Windows, iPhone & Android, and the Chrome extension that reads any website out loud.`)
};

const es_funnel_ob_recap_devices = /** @type {(inputs: Funnel_Ob_Recap_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úsalo en la web, en Mac y Windows, en iPhone y Android, y con la extensión de Chrome que lee cualquier web en voz alta.`)
};

/**
* | output |
* | --- |
* | "Use it on web, Mac & Windows, iPhone & Android, and the Chrome extension that reads any website out loud." |
*
* @param {Funnel_Ob_Recap_DevicesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_devices = /** @type {((inputs?: Funnel_Ob_Recap_DevicesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_DevicesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_devices(inputs)
	return en_funnel_ob_recap_devices(inputs)
});